import addMonths from "date-fns/addMonths";
import addYears from "date-fns/addYears";
import format from "date-fns/format";
import startOfMonth from "date-fns/startOfMonth";
import startOfQuarter from "date-fns/startOfQuarter";
import startOfYear from "date-fns/startOfYear";

import { ApiEndpoint } from "utils/baseFetcher";

export const AVAILABLE_TIMESPAN = [
  {
    id: "MTD",
    title: "MTD",
    since: format(startOfMonth(new Date()), "yyyy-MM-dd"),
  },
  {
    id: "1M",
    title: "1M",
    since: format(addMonths(new Date(), -1), "yyyy-MM-dd"),
  },
  {
    id: "QTD",
    title: "QTD",
    since: format(startOfQuarter(new Date()), "yyyy-MM-dd"),
  },
  {
    id: "3M",
    title: "3M",
    since: format(addMonths(new Date(), -3), "yyyy-MM-dd"),
  },
  {
    id: "6M",
    title: "6M",
    since: format(addMonths(new Date(), -6), "yyyy-MM-dd"),
  },
  {
    id: "YTD",
    title: "YTD",
    since: format(startOfYear(new Date()), "yyyy-MM-dd"),
  },
  {
    id: "1Y",
    title: "1Y",
    since: format(addYears(new Date(), -1), "yyyy-MM-dd"),
  },
  {
    id: "3Y",
    title: "3Y",
    since: format(addYears(new Date(), -3), "yyyy-MM-dd"),
  },
  {
    id: "5y",
    title: "5Y",
    since: format(addYears(new Date(), -5), "yyyy-MM-dd"),
  },
  {
    id: "10y",
    title: "10Y",
    since: format(addYears(new Date(), -10), "yyyy-MM-dd"),
  },
];

export const AVAILABLE_KEYS = [
  { id: "low", title: "Low" },
  { id: "avg", title: "Avg" },
  { id: "high", title: "High" },
  { id: "est", title: "Est" },
];

export function chartTargetPriceUrl(
  entityId: string,
  key: string,
  since?: Date | string
): any {
  const url = new ApiEndpoint("/api/v3/consensus/graphs/target-price");
  url.searchParams.append("entity-id", entityId);
  url.searchParams.append("key", key);
  if (since) {
    url.searchParams.append("date-from", since.toString());
  }
  return url.href;
}
